<template>
  <div class="c-creat-image" :class="{ 'm-short': !caption }">
    <span class="m-remove" @click="$emit('on-delete', index)">x</span>
    <div class="c-thumb">
      <Row :gutter="6">
        <Col span="12" v-for="(t, idx) in data" :key="idx">
          <div class="c-thumb-wrapper m-default-bg">
            <Spin v-show="t.loading" fix>
              <Icon type="ios-loading" size="30" class="c-fix-loading"></Icon>
              <div>上传中...</div>
            </Spin>
            <div class="c-alt-upload" :class="{ 'c-hide-upload': updated(t.url) }">
              <div class="c-alt-container" v-if="idx">
                <Button type="primary" @click="smartClick(index, Boolean(data[0] && data[0].poster_url))">选择封面</Button>
                <Upload action="" :before-upload="beforeUploadImage">
                  <Button type="default" @click="groupIndex = idx">本地上传</Button>
                </Upload>
              </div>
              <div class="c-alt-container" v-else>
                <Button type="primary" @click="$emit('on-select', { index })">选择视频</Button>
                <Upload action="" :before-upload="beforeUploadVideo">
                  <Button type="default" @click="groupIndex = idx">本地上传</Button>
                </Upload>
              </div>
              <div v-if="idx" class="c-alt-txt m-muted">
                <span>需和视频同比例，大小不超过500k</span>
                <span>横版16:9，最低尺寸1280*720</span>
                <span>竖版9:16，最低尺寸720*1280</span>
              </div>
              <div v-else class="c-alt-txt m-muted">
                <span>视频码率 >=516kbps</span>
                <span>横版分辨率>=1280*720，大小&lt;=100M</span>
                <span>竖版分辨率>=720*1280，大小&lt;=100M</span>
              </div>
              <div class="c-action-container">
                <span v-if="!idx && t.url" @click="$emit('on-play', t.url)" class="c-on-play">点我播放视频</span>
              </div>
            </div>
            <div v-if="!idx && t.poster_url" class="c-alt-play">
              <Icon type="md-arrow-dropright-circle" size="68" color="#FFFFFF" />
            </div>
            <span v-if="t.msg" class="c-thumb-error">不符合：{{ t.msg }}</span>
            <img
              v-if="t.url || t.poster_url"
              :src="idx ? t.url : t.poster_url"
              alt=""
              :class="{ 'vertical-img': t.image_mode.includes('VERTICAL') }"
            />
          </div>
        </Col>
      </Row>
      <div v-if="caption" class="c-caption">
        <textarea
          ref="title"
          class="c-caption-input"
          v-model="title"
          placeholder="请输入创意标题（12~60个字符,中文占两个字符）"
          @keyup="clearEvent"
          @keydown="keyEvent"
          @click="handleClick"
        ></textarea>
        <span class="c-caption-num m-muted">
          <ins :class="warnClass">{{ len }}</ins
          >/60
        </span>
      </div>
    </div>
    <div v-if="caption" class="c-words">
      <span>动态词插入：</span>
      <a v-for="item in words" :key="item.creative_word_id" @click="setWord(item, index)">{{ item.name }}</a>
      <div style="margin-top: 6px">
        <Button type="error" @click="$emit('on-clear', index)">清除</Button>
        <span style="color: #ff4400; display: none">(要删除动态词请点清除按钮，否则会报错!)</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getByteLen, isArray, isEmpty, timeout } from '@/common/js/utils'
export default {
  name: 'groupImage',
  props: {
    value: {
      type: String
    },
    index: {
      type: Number
    },
    data: {
      type: Array
    },
    words: {
      type: Array
    },
    trends: {
      type: Array
    },
    caption: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    updated() {
      return (ret) => Boolean(ret)
    },
    title: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      let num = 0
      const val = this.title
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      if (!isEmpty(val)) {
        const values = val.match(regexp)
        num += getByteLen(val)
        if (isArray(values)) {
          values.forEach((ret) => {
            ret === '{节日}' && (num += 4)
            ret === '{日期}' && (num += 6)
            ret === '{地点}' && (num += 2)
          })
        }
      }
      return num
    },
    warnClass() {
      return this.len > 60 ? 'm-num-warn' : ''
    },
    dynPos() {
      const regexp = /{[\u4e00-\u9fa5]{2,}}/g
      const values = this.value.match(regexp)
      if (isArray(values)) {
        return values
          .filter((ret) => this.words.map((met) => `{${met.name}}`).includes(ret))
          .map((m) => {
            const min = this.value.indexOf(m)
            return [min, min + m.length]
          })
      } else return []
    }
  },
  methods: {
    setWord(item, index) {
      const cut = this.$refs.title.selectionStart
      const trend = Object.assign({}, item, { cut })
      const suffix = this.title.indexOf('{')
      if (suffix > -1) {
        // 方向添加
        let direction
        const lastSuffix = this.title.lastIndexOf('{')
        if (cut <= suffix) direction = 'left'
        else if (cut <= lastSuffix) direction = 'right'
        else direction = 'plus-right'
        this.$emit('on-trend', { trend, index, direction })
      } else {
        this.$emit('on-trend', { trend, index }) // 没有动态词
      }
    },
    smartClick(index, url) {
      // 是否选择视频
      if (url) {
        this.$emit('on-select', { index, idx: 'img' })
      } else {
        this.$emit('on-select', { index })
      }
    },
    beforeUploadImage(file) {
      const { size, name, type } = file

      if (!['image/png', 'image/gif', 'image/jpeg'].includes(type)) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 格式错误，只支持 jpg、jpeg、png、gif 格式 `
        })
        return false
      }

      if (size > 500000) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 超过限制大小`
        })
        return false
      }

      this.getFileInfo(file)
        .then((data) => {
          const { width, height } = data
          const vertical = height > width
          this.$emit('on-upload', { index: this.index, idx: this.groupIndex, file, vertical })
        })
        .catch((err) => {
          this.$Message.error({
            closable: true,
            duration: 5,
            content: `读取文件信息出错： ${err}`
          })
        })
      return false
    },
    beforeUploadVideo(file) {
      const { size, name, type } = file
      if (
        ![
          'video/mp4',
          'video/quicktime',
          'video/x-msvideo',
          'video/x-ms-wmv',
          'video/webm',
          'video/ogg',
          'application/octet-stream'
        ].includes(type)
      ) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 格式错误，只支持 mp4、wmv、webm、flv 格式 `
        })
        return false
      }
      if (size > 100000000) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 超过限制大小`
        })
        return false
      }
      this.$emit('on-loading', { index: this.index, idx: this.groupIndex })
      this.$emit('on-upload', { index: this.index, idx: this.groupIndex, file, vertical: false })
      return false
    },
    getFileInfo(file) {
      const reader = new FileReader()
      const image = new Image()

      return new Promise((resolve, reject) => {
        reader.onload = function (e) {
          const data = e.target.result
          image.onload = function () {
            const width = image.width
            const height = image.height
            resolve({ width, height })
          }
          image.src = data
        }
        reader.readAsDataURL(file)
      })
    },
    // 点中动态词
    handleClick() {
      const input = this.$refs.title
      const { selectionStart } = input
      if (isArray(this.dynPos) && this.dynPos.length) {
        let val
        const getMid = (num, min, max) => {
          if (num > min && num < max) return max
          else return num
        }
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMid(selectionStart, min, max)
          return max === val
        })
        input.selectionStart = input.selectionEnd = val
      }
    },
    // 动态词 键盘监听
    keyEvent(e) {
      const input = this.$refs.title
      const { selectionStart } = input
      const getMax = (num, min, max) => {
        if (num === min) return max
        else return num
      }
      const getMin = (num, min, max) => {
        if (num === max) return min
        else return num
      }
      const getDelMax = (num, min, max) => {
        if (num === max) return [min, max]
        else return num
      }
      const getDelMin = (num, min, max) => {
        if (num === min) return [min, max]
        else return num
      }
      const getMid = (num, min, max) => num > min && num < max
      if (window.event.shiftKey && (e.keyCode === 219 || e.keyCode === 221)) {
        window.event.returnValue = false
        this.$Notice.error({ title: '系统提示', desc: '创意标题禁止使用 ‘{’ 和 ‘}’ 。' })
        return
      } else if (window.event.ctrlKey && e.keyCode === 90) {
        window.event.returnValue = false
        this.$Notice.error({ title: '系统提示', desc: '创意标题不允许使用撤回！' })
        return
      }
      if (isArray(this.dynPos) && !this.dynPos.length) return
      if (e.keyCode === 37) {
        // left arrow
        let val
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMin(selectionStart, min, max)
          return min === val
        })
        if (selectionStart !== val) window.event.returnValue = false
        input.selectionStart = input.selectionEnd = val
      } else if (e.keyCode === 39) {
        // right arrow
        let val
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMax(selectionStart, min, max)
          return selectionStart !== max && max === val
        })
        if (selectionStart !== val) window.event.returnValue = false
        input.selectionStart = input.selectionEnd = val
      } else if (e.keyCode === 8) {
        // backspace
        let val
        let order
        const lock = this.dynPos.some((ret) => {
          const [min, max] = ret
          return getMid(selectionStart, min, max)
        })
        if (lock) window.event.returnValue = false
        this.dynPos.some((ret, i) => {
          const [min, max] = ret
          val = getDelMax(selectionStart, min, max)
          order = i
          return isArray(val)
        })
        // 发事件出去删除动态词
        if (isArray(val)) {
          const [min, max] = val
          input.selectionStart = min
          input.selectionEnd = max
          timeout(300).then(() => {
            this.$emit('on-del-trend', { index: this.index, order })
          })
        }
      } else if (e.keyCode === 46) {
        // delete
        let val
        let order
        const lock = this.dynPos.some((ret) => {
          const [min, max] = ret
          return getMid(selectionStart, min, max)
        })
        if (lock) window.event.returnValue = false
        this.dynPos.some((ret, i) => {
          const [min, max] = ret
          val = getDelMin(selectionStart, min, max)
          order = i
          return isArray(val)
        })
        if (isArray(val)) {
          const [min, max] = val
          input.selectionStart = min
          input.selectionEnd = max
          timeout(300).then(() => {
            this.$emit('on-del-trend', { index: this.index, order })
          })
        }
      }
    },
    clearEvent(e) {
      if ([8, 46].includes(e.keyCode) && isArray(this.dynPos) && !this.dynPos.length) {
        this.$emit('on-clear', this.index)
      }
    }
  },
  data() {
    return {
      groupIndex: 0
    }
  }
}
</script>
<style lang="scss" scoped>
.m-mini {
  width: 228px !important;
}

.m-short {
  min-height: 165px !important;
}

.m-remove {
  position: absolute;
  cursor: pointer;
  color: #fff;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 80%;
  border-radius: 9px;
  background-color: #ff635c;
  text-align: center;
  display: block;
  opacity: 0;
  z-index: 11;
  top: -6px;
  right: 0;
  transition: opacity 0.2s ease-in-out;
}

.m-default-bg {
  background-color: #e8e8e8;
}

.m-muted {
  color: #666;
  font-size: 85%;
}

.m-num-warn {
  color: #ff4400;
}

.c-creat-image {
  width: 506px;
  min-height: 255px;
  padding-right: 16px;
  padding-bottom: 15px;
  position: relative;
  float: left;

  &:hover {
    .c-thumb {
      border-color: #ff635c;
    }

    .m-remove {
      opacity: 1;
    }
  }

  .c-thumb {
    margin-right: -4px;
    background-color: #fff;
    border: solid 1px #ddd;
    transition: border 0.2s ease-in-out;

    .c-thumb-wrapper {
      width: 100%;
      height: 165px;
      position: relative;
      z-index: 9;

      .c-thumb-error {
        display: inline-block;
        position: absolute;
        z-index: 1;
        margin-top: 3px;
        padding: 2px 4px 0;
        line-height: 1.3;
        color: #ff4400;
        background: #000;
        background: -webkit-linear-gradient(left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
        background: -ms-linear-gradient(left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
        background: -moz-linear-gradient(left, rgba(255, 255, 255, 1) 100%, rgba(255, 255, 255, 0) 0%);
        background: -o-linear-gradient(left, rgba(255, 255, 255, 1) 100%, rgba(255, 255, 255, 0) 0%);
      }

      img {
        width: 100%;
        height: 100%;
        display: block;

        &.vertical-img {
          width: 120px;
          margin: 0 auto;
        }
      }

      .c-alt-upload {
        width: 100%;
        height: 100%;
        padding: 0 12px;
        position: absolute;
        z-index: 7;
        top: 0;
        left: 0;
        text-align: center;

        .c-alt-container {
          padding: 36px 0px 12px;
          display: flex;
          justify-content: center;
        }

        .c-alt-txt {
          padding: 6px 0;

          span {
            display: block;
            line-height: 1.4;
          }
        }

        .c-action-container {
          line-height: 22px;
          text-align: right;

          .c-on-play {
            color: #ffff00;
            cursor: pointer;

            &:hover {
              color: #ff6600;
            }
          }
        }
      }

      .c-alt-play {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .c-hide-upload {
      opacity: 0;

      &:hover {
        opacity: 1;
        background-color: rgba(0, 0, 0, 0.6);

        .c-alt-txt {
          color: #fff;
        }
      }
    }
  }

  .c-caption {
    padding: 8px;
    text-align: right;

    .c-caption-input {
      display: block;
      width: 100%;
      background-color: #fff;
      background-image: none;
      border: 0;
      overflow: hidden;
      resize: none;
      outline: 0;
    }
  }

  .c-words {
    padding: 5px 0;
    line-height: 20px;

    a {
      padding: 0 5px;
      white-space: nowrap;
    }
  }
}

.c-fix-loading {
  margin-bottom: 12px;
  animation: ani-demo-spin 1s linear infinite;
}
</style>
